<template>
    <div class="component-container">

        <!-- FIRST SECTION -->

        <div class="aar-infopage-left">
            <transition type="animation" enter-active-class="animate__animated animate__fadeInUp" appear>
              <h2 class="aar-info-heading">{{$t('infoPageIntroSectionTitle')}}</h2>
            </transition>
            <transition-group type="animation" enter-active-class="animate__animated animate__fadeInUp animate__delay-04s" appear>
              <p key="1" class="aar-info-text has-small-margin-bottom">{{$t('infoPageIntroSectionExp1')}}</p>
              <p key="2" class="aar-info-text has-med-long-margin-bottom">{{$t('infoPageIntroSectionExp2')}}</p>
            </transition-group>
        </div>

        <div class="aar-infopage-right">
            <model-viewer
                id="model-viewer-hidden-mobile"
                auto-rotate camera-controls
                data-js-focus-visible
                shadow-intensity="1"
                stage-light-intensity="3" environment-intensity="2"
                camera-orbit="0deg 65deg 35m"
                ar
                src="https://ar.accadigital.com/models/plane-engine/plane-engine.gltf"
                class="aar-infopage-right__mv">
                <div class="lazy-load-poster" id="poster-3" slot="poster"></div>
            </model-viewer>
        </div>

         <!-- END FIRST SECTION -->
         
         <!-- SECOND SECTION -->
        

        <div class="aar-info-page-bg has-med-long-margin-bottom">
          <div class="aar-info-page-bg__left">
            <model-viewer
                auto-rotate camera-controls
                data-js-focus-visible
                shadow-intensity="1"
                stage-light-intensity="3" environment-intensity="2"
                camera-orbit="0deg 65deg 3m"
                ar
                loading="lazy"
                src="https://ar.accadigital.com/models/soda-can/soda-can.gltf"
                class="aar-infopage-right__mv">
                <div class="lazy-load-poster" id="poster-2" slot="poster"></div>
            </model-viewer>
          </div>
            <div class="aar-info-page-bg__right">
              <h2 class="aar-info-heading is-white">{{$t('infoPageARInfoTitle')}}</h2>
              <p key="1" class="aar-info-text is-white has-small-margin-bottom">{{$t('infoPageARInfoExp1')}}</p>
              <p key="2" class="aar-info-text is-white has-small-margin-bottom">{{$t('infoPageARInfoExp2')}}</p>
              <p key="3" class="aar-info-text is-white">{{$t('infoPageARInfoExp3')}}</p>
            </div>
        </div>

         <!-- END SECOND SECTION -->

         <!-- THIRD SECTION -->

        <div class="aar-infopage-left">
              <h2 class="aar-info-heading mobile-margin-section-heading">{{$t('sloganTitle')}}</h2>
              <p key="1" class="aar-info-text has-small-margin-bottom">{{$t('sloganExp1')}}</p>
              <p key="2" class="aar-info-text has-small-margin-bottom">{{$t('sloganExp2')}} </p>
              <p key="3" class="aar-info-text has-med-long-margin-bottom">{{$t('sloganExp3')}} </p>
        </div>

        <div class="aar-infopage-right">
            <model-viewer
                auto-rotate camera-controls
                data-js-focus-visible
                shadow-intensity="1"
                stage-light-intensity="3" environment-intensity="2"
                camera-orbit="0deg 65deg 3m"
                ar
                src="https://ar.accadigital.com/models/coffeetable/var1/coffeetable.gltf"
                class="aar-infopage-right__mv">
                <div class="lazy-load-poster" id="poster-4" slot="poster"></div>
            </model-viewer>
        </div>

         <!-- END THIRD SECTION -->

        <!-- MODEL PERFORMANCE SECTION -->

        <div class="aar-info-page-bg has-med-long-margin-bottom">

          <div class="aar-info-page__comparison_text">
             <h2 style="margin-bottom: unset;" class="aar-info-heading is-white">{{$t('comparisonSectionTitle')}}</h2>
             <h2 class="aar-info-heading is-white">{{$t('comparisonSectionTitle2')}}</h2>
             <div class="aar-info-page-comparison__container">
                <div class="aar-info-page__comparison-div">
                <p key="1" class="aar-info-text is-white has-small-margin-bottom"> {{$t('comparisonSectionText1')}} </p>
                <p key="2" class="aar-info-text is-white has-small-margin-bottom"> {{$t('comparisonSectionText2')}} </p>
             </div>
             <div class="aar-info-page__comparison-div">
                <p key="3" class="aar-info-text is-white has-small-margin-bottom"> {{$t('comparisonSectionText3')}}</p>
                <p id="mobile-final" key="4" class="aar-info-text is-white has-med-long-margin-bottom ">{{$t('comparisonSectionText4')}} </p>
             </div>
             </div>

          </div>

          <div id="slowModel" class="aar-info-page-bg__left">
            <model-viewer
                id="unoptimizedModel"
                auto-rotate camera-controls
                data-js-focus-visible
                shadow-intensity="1"
                stage-light-intensity="3" environment-intensity="2"
                camera-orbit="0deg 65deg 3m"
                ar
                loading="lazy"
                reveal="manual"
                src="https://ar.accadigital.com/models/unoptimized/unoptimized.gltf"
                ios-src="https://ar.accadigital.com/models/unoptimized/unoptimized.usdz"
                class="aar-infopage-right__mv">
                <div class="lazy-load-poster" id="poster-1" slot="poster"></div>
            </model-viewer>
            <p style="text-align: center; font-size: 16px; margin-top: 1rem;;" class="aar-info-text is-white">{{$t('unptimizedModelExp')}}</p>
            <div v-if="!unoptimizedModelLoaded" @click="revealModel" id="button-load-1">{{$t('downloadModelText')}}</div>
            
          </div>
            <div id="fastModel" class="aar-info-page-bg__right">
            <model-viewer
                id="optimizedModel"
                auto-rotate camera-controls
                data-js-focus-visible
                shadow-intensity="1"
                stage-light-intensity="3" environment-intensity="2"
                camera-orbit="0deg 65deg 3m"
                ar
                loading="lazy"
                reveal="manual"
                src="https://ar.accadigital.com/models/sofa/leather/sofa.gltf"
                ios-src="https://ar.accadigital.com/models/sofa/leather/sofa.usdz"
                class="aar-infopage-right__mv">
                <div class="lazy-load-poster" id="poster-1" slot="poster"></div>
            </model-viewer>
              <p style="text-align: center; font-size: 16px; margin-top: 1rem;" class="aar-info-text is-white">{{$t('optimizedModelExp')}}</p>
                <div v-if="!optimizedModelLoaded" @click="revealOptimizedModel" id="button-load-2">{{$t('downloadModelText')}}</div>
        </div>
        </div>

        <!-- END MODEL PERFORMANCE SECTION -->

      <h2 class="aar-info-heading acordion-heading">{{$t('infoPageFAQTitle')}}</h2>
      <ac-acordion class="ac-acordion" :texts=texts[$i18n.locale]></ac-acordion>
    </div>
</template>


<script>
    import { ModelViewer } from "@google/model-viewer";
    import acAcordion from "./reusable/acAcordion.vue"


export default {
  name: 'InfoPage',
  data(){
    return {
      unoptimizedModelLoaded: false,
      optimizedModelLoaded: false,
      texts: {
        en:[
                {
                  id: 0,
                  question: "What are the main uses for AR?",
                  answer: "Use cases for Augmented Reality are limited only by your imagination. AR creates numerous advantages in situations where your clients would buy products for their homes and offices, as it makes it possible for users to place the products right on their living spaces. AR is especially useful in cases where you offer variations in your products, such as color, size or material, because your prospective clients are able to test individual options themselves. This creates engagement for your products and makes it more likely for visitors to turn into paying customers."
                },
                {
                  id: 1,
                  question: "How does AR make life easier for our customers, or make online shopping a more pleasant experience? ", 
                  answer:`AR makes life easier because it adds a crucial dimension to online shopping. With AR, difficult questions about whether a product would fit into a particular space in your clients’ homes or how they would blend in to the existing design are answered within seconds. This means that clients feel at ease when shopping for your products: Questions like, “Would this refrigerator fit into my kitchen?”, “Would this wardrobe be too large for my bedroom?, “Would buying this dresser make my room feel cramped?” and “Which color option would look the best in my living room?” are no longer sources of confusion thanks to AR.`
                },
                {
                  id: 2,
                  question: "Does AR only target the end user? Are there corporate use cases?", 
                  answer:"Using AR for end-users is obvious, but it is also used worldwide in corporate settings, from training employees, displaying product ranges, offering technical demonstrations and so on. The fundamental advantage of AR is that it offers high-quality and realistic alternatives to physical objects. You can rely on augmented reality experiences in any scenario where you would save time, money and resources by not having to display the actual product. "
                },
                {
                  id: 3,
                  question: "Do I need a specific device to use AR? How does AR work on computers?",
                  answer: "AR works on all modern phones and tablets, so you and your customers don’t need additional devices. Augmented Reality requires a camera to project the model to the living space – so it’s not intended for use in computers. 3D models, hovewer, are easily explored on these devices.",
                },
                {
                  id: 4,
                  question: "How do we present models an AR experiences to our customers?", 
                  answer:"It’s up to you. We can integrate AR experiences to your existing websites, build websites / mobile apps from scratch or create specific sub-domains for your AR experiences (like ar.yourwebsite.com or showroom.yourwebsite.com). We can also help integrate 3D Models to third party programs that support AR experiences."
                },
                {
                  id: 5,
                  question: "What is the basic workflow for presenting our products in AR?", 
                  answer:" All you have to do is to decide which products and services will be a part of your 3D / AR experience, and we take care of everything else. After we receive your product / service list, we create your 3D Models, optimize them for online use and integrate them into your online platforms. "
                },
                {
                  id: 6,
                  question: "Does it help if we already have 3D Models of our products?",
                  answer: "It depends. It could be helpful to have 3D models in some cases, but most of the time, the models need to be recreated for great online experiences. We can give you more information after we analyze your existing models before starting your projects."
                }

          ],
        tr:
          [
            {
              id:0,
              question: "AR Teknolojisinin ne gibi kullanım alanları olabilir?",
              answer: "Arttırılmış Gerçeklik, kullanım alanı açısından neredeyse sınırsız potansiyel taşıyor. Müşterilerin satın alıp evlerine, ofislerine veya zaman geçirdikleri başka bir alana yerleştireceği ürünler konusunda, arttırılmış gerçeklik başka hiçbir mecranın sunamayacağı bir imkan yaratıyor. Kullanıcılar, AR teknolojisi sayesinde ürünü bu yaşam alanlarında doğrudan görüntüleyip, kendilerine uygun tercihleri yapabiliyor. Özellikle renk - boyut - malzeme gibi alternatifler sunduğunuz durumlarda, müşterilerinizin tercih edeceği ürünü seçmesi ve kafasında canlandırması çok daha kolay hale geliyor."
            },
            {
              id: 1,
              question: "AR teknolojisinin hayatı kolaylaştıracağı ve alışverişi daha keyifli bir deneyim haline getireceği noktalar ile neyi kastediyorsunuz?", 
              answer:`Özellikle internet üzerinden, ürünleri fiziksel olarak görmeden alışveriş yaptığınızda, AR teknolojisinin sağlayacağı avantajların sayısı oldukça fazla. Evinize istediğiniz ürünün, hayal ettiğiniz bölgeye sığıp sıpmayacağını görmekten, bu tarz ürünlerin evinizin içinde nasıl gözükeceğine kadar pek çok soru, AR sayesinde saniyeler içinde cevaplanabiliyor. Bu sayede, "Bu bulaşık makinesi / buzdolabı benim mutfağımdaki boşluğa sığar mı?", "Bu gardrop yatak otamı çok küçültür mü? Ferah bir oda için hangi boyutu tercih etmeliyim?", "Bu kütüphane, salonumdaki diğer mobilyalarla uyumlu durur mu? Uyumlu durması için, farklı renk alternatiflerinden hangisini seçmeliyim?, "Bu tablo, evimdeki diğer tabloların yanında nasıl gözükür? Bunu diğerleri ile nasıl bir araya getirebilirim?" gibi sorular, AR sayesinde gerçeğe yakın cevaplar buluyor.`
            },
            {
              id: 2,
              question: "AR sadece son tüketiciyi mi hedefliyor? Kurumsal kullanım alanları var mı?", 
              answer:"AR'ın son kullanıcı için kullanımları çok bariz olsa da, bu teknoloji dünya genelinde pek çok kurumsal şirket tarafından da benimseniyor. Arttırılmış Gerçeklik, özellikle ürün odaklı eğitimlerde ve teknik malzeme, cihaz ve bileşenlerin tanıtımında kullanılabiliyor. "
            },
            {
              id: 3,
              question: "Arttırılmış Gerçeklik (AR) teknolojisini kullanmak için herhangi bir cihaz gerekiyor mu? AR teknolojisi bilgisayarlarda nasıl çalışıyor?", 
              answer:"Arttırılmış Gerçeklik teknolojisi, tüm modern cep telefonlarında ve tabletlerde çalışıyor. AR teknolojisinin çalışma prensibi, gösterilen ürünü kamerayla çekilen bir ortama dijital olarak yerleştirmeye dayanıyor. Bu nedenle, ürünlerinizin üç boyutlu modelleri bilgisayarlardan görüntülenebilse de, AR deneyimi bu cihazlarda yaratılamıyor."
            },
            {
              id: 4,
              question: "Model ve AR ürünlerini müşterilerimize nasıl ulaştıracağız?", 
              answer:"Model ve AR ürünlerinin kullanıcılara sunulması konusundaki tüm süreçler sizin tercihinize kalıyor. Acca AR olarak, ürünlerinizi mevcut siteniz / uygulamanız vasıtasıyla kullanıcılarınıza ulaştırabildiğimiz gibi, sizin için sıfırdan web siteleri ve uygulamalar da hazırlayabiliyoruz. Tercih etmeniz durumunda, AR deneyimini ayrı bir site veya alt alan adı üzerinden de sunabiliyoruz (showroom.siteniz.com veya ar.siteniz.com gibi). Aynı zamanda, Yemeksepeti gibi destekleyen platformlar için AR entegrasyon desteği de sağlayabiliyoruz."
            },
            
            {
              id: 5,
              question: "Ürünlerimizi bu şekilde sunmaya karar verirsek, süreç nasıl ilerliyor?", 
              answer:"Sizin tek yapmanız gereken, hangi ürün ve servislerinizi üç boyutlu model / arttırılmış gerçeklik olarak sunmak istediğinize karar vermek. Geri kalan tüm adımlar bizim sorumluluğumuzda. Ürün ve hizmet listeniz bize ulaştıktan sonra, seçtiğiniz ürünler üç boyutlu olarak modelleniyor, web sitenize / uygulamalarınıza ekleniyor ve arttırılmış gerçeklik üzerinden kullanıcılara sunuluyor. "
            },
            {
              id:6,
              question: "Ürünlerimizin daha önceden hazırlanmış üç boyutlu modellerinin olması, süreci hızlandırır mı?",
              answer: "Bu sorunun cevabı, mevcut modellerinizin yapısına göre değişiklik gösteriyor. Daha önceden hazırlanmış üç boyutlu modellerin olması modelleme aşamasını hızlandırabilecek olsa da, bunların web üzerinden sunulması için farklı şekillerde yeniden yaratılması gerekiyor. Elinizde web için optimize edilmiş üç boyutlu modeller varsa, bu durum süreci hızlandırıyor. Bunun dışındaki modeller için, proje aşamasında modellerin incelenmesi gerekiyor."
            }
            ]
      }
    }
  },
  methods: {
    revealModel() {
      const model = document.getElementById("unoptimizedModel")
      model.dismissPoster()
      this.unoptimizedModelLoaded = true
    },
    revealOptimizedModel(){
      const model = document.getElementById("optimizedModel")
      model.dismissPoster()
      this.optimizedModelLoaded = true

    },

  },
  components: {
    ModelViewer: ModelViewer,
    acAcordion: acAcordion
  }
}
</script>


<style scoped lang="scss">
  @import "../styles/core/variables.scss";
  @import "../styles/global/helpers.scss";
  @import "../styles/global/components.scss";
  @import "../styles/global/animations.scss";

  *{
    row-gap: 0 !important
  }

  .component-container{
    align-items: flex-start;
    padding-top: 2%;

}

  .aar-infopage-left{
    grid-column: 2 / 7;
  }
  
  .aar-infopage-right{
    grid-column: 7 / 12;
  }

  .aar-infopage-right{
  }

  .aar-info-page-bg{
    grid-column: 1 / -1;
    background-color: #111111;
    display: grid;
    grid-template-columns: inherit;
    padding: 8.4rem 0;
    column-gap: inherit;


    &__left{
      grid-column: 2 / 7;
    }

    &__right{
      grid-column: 7 / 12;
    }
  }

  .aar-info-page__comparison_text{
    grid-column: 2 / 12;
  }

  .aar-info-page-comparison__container{
    width: 100%;
    display: flex;
    justify-content: space-between;
  }

  .aar-info-page__comparison-div{
    width: 48%;
  }

    // Model Viewer

  .aar-infopage-right__mv{
    max-height: 50vh;
  }

  .acordion-heading{
    grid-column: 3 / span 3;
  }

  .ac-acordion{
    grid-column: 3 / 11;
  }

  // MODEL VIEWER ADDITIONAL PROPERTIES

  .lazy-load-poster{
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
    --poster-color: transparent;
  }

  #poster-1{
    background-image: url('https://ar.accadigital.com/img/sofa.png');  }

  #poster-2{
    background-image: url('https://ar.accadigital.com/img/sofa.png');
  }

  #poster-3{
        background-image: url('https://ar.accadigital.com/img/plane-engine.png');
  }

  #poster-4{
        background-image: url('https://ar.accadigital.com/img/coffeetable.png');
  }


  .info-page__button-container{
    width: 100%;
    display: flex;
    justify-content: center;
    
  }

  #slowModel, #fastModel{
    position: relative;
  }

  #button-load-1 {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    border: 1px solid white;
    color: white;
    cursor: pointer;
    border-radius: 4px;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    font-weight: 500;
    font-size: 1.6rem;
    width: 22.3rem;
    height: 50px;
  }
  
  #button-load-2 {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    color: white;
    border: 1px solid white;
    cursor: pointer;
    border-radius: 4px;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    font-weight: 500;
    font-size: 1.6rem;
    width: 22.3rem;
    height: 50px;
  }

  #button-load-1:hover, #button-load-2:hover{
    background-color: white;
    color: black;
  }

  .infopage-final {
    display: none;
  }

  // Helpers

  .is-white{
    color: white;
  }

  #unoptimizedModel::part(default-progress-bar){
    background-color: red;
  }

  #optimizedModel::part(default-progress-bar){
    background-color: green;;
  }

  model-viewer {
        height: 65.7rem;
        width: 100%;

    }

    
    @media screen and (max-width: $tablet-portrait){
      .aar-info-page-comparison__container{
        flex-direction: column;
      }

      .aar-info-page__comparison-div{
        width: 100%;
      }

      #slowModel{
        margin-bottom: 2rem;
      }
    }
    


  @media screen and (max-width: $mobile-small){
    .component-container{
        display: flex;
        flex-direction: column;

        padding-top: 4.2rem;
        padding-bottom: 4.2rem;
    }

    #model-viewer-hidden-mobile{
      display: none;
    }

    .aar-infopage-left .aar-info-text:last-child{
      margin-bottom: 4.2rem;
    }

    .aar-infopage-right .aar-info-text:last-child{
      margin-bottom: 4.2rem;
    }

    .mobile-margin-section-heading{
      margin: 4.2rem 0;
    }


    .infopage-final {
      display: flex;
      flex-direction: column;
      align-items: center;
    }

    .aar-info__img{
        max-width: 50rem;
        margin-top: -10rem;
        margin-bottom: -10rem;
      }
  
    .mobile-margin-bottom {
        margin-bottom: 3rem;

    }
      
      .aar-infopage-left, .aar-infopage-right, .aar-info-page-bg, .ac-acordion, .acordion-heading{
        padding-left: 1.6rem;
        padding-right: 1.6rem;      
      }

      .acordion-heading{
        margin-top: 2rem;
      }


      .aar-info-page-bg{
        display: flex;
        flex-direction: column;
      
      }

      .aar-infopage-right{
        width: 100%;
      }

      #mobile-final {
        margin-bottom: 2rem;
      }
            }




</style>
